/**
 * @flow
 */
/* global __DEV__ */

import { applyMiddleware, createStore, compose } from 'redux';
import type { Middleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';

import { scrollMiddleware, messageForHandler, modalOpenHelper } from './middleware';
import rootReducer from './reducers';

function configureStore(preloadedState: Object = {}) {

  // Setup middleware
  const sagaMiddleware = createSagaMiddleware();

  // $FlowIgnore
  const middleware: Middleware<*, *>[] = [messageForHandler, modalOpenHelper, scrollMiddleware, sagaMiddleware];

  if (__DEV__) {
    // Debug for dev if not set
    if (!window.localStorage.getItem('debug')) {
      window.localStorage.setItem('debug', process.env.REACT_APP_DEBUG);
    }

    // eslint-disable-next-line global-require
    window.DUMP_RESPONSE = require('~/utils/dumpResponse').default;

    // Logging in dev only
    const logger = createLogger({
      diff: process.env.REACT_APP_LOGGER_DIFF,
      diffPredicate: (getState, action): boolean =>
        !['Design/UPDATE'].includes(action.type),
      duration: true,
      collapsed: (getState, action, logEntry) => !logEntry.error,
    });
    middleware.push(logger);

    // Redux state invarent check
    // eslint-disable-next-line global-require
    middleware.push(require('redux-immutable-state-invariant').default());

    // Monkey patch react to help us figure out render issues
    // eslint-disable-next-line global-require
    // const { whyDidYouUpdate } = require('why-did-you-update');
    // whyDidYouUpdate(React);
  }

  /* eslint-disable */
  const composeSetup =
  process.env.NODE_ENV !== 'production' &&
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
  /* eslint-enable */

  const applyedMiddleware = applyMiddleware(...middleware);

  const store = createStore(
    rootReducer,
    preloadedState,
    composeSetup(applyedMiddleware), // allows redux devtools to watch sagas
  );

  // $FlowIgnore
  store.run = sagaMiddleware.run;

  return store;

}

export default configureStore;



// WEBPACK FOOTER //
// ./src/configureStore.js